import * as React from "react";
import type { SVGProps } from "react";
const SvgRomania = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 720" {...props}>
    <path
      d="M0 .5h426.67v719H0z"
      style={{
        fill: "#263779",
      }}
    />
    <path
      d="M426.67.5h426.67v719H426.67z"
      style={{
        fill: "#fad016",
      }}
    />
    <path
      d="M853.33.5H1280v719H853.33z"
      style={{
        fill: "#cd2028",
      }}
    />
  </svg>
);
export default SvgRomania;
